import React from "react";

const TermsAndConditionsComp = ({ form, updateTerm, removeTerm, addTerm }) => {
	return (
		<div className="card-box">
			<h6>Terms & Conditions</h6>

			{form.terms.map((t, i) => (
				<div key={i} className="d-flex gap-2 mt-2">
					<input
						value={t}
						onChange={(e) => updateTerm(i, e.target.value)}
						className="form-control custom-input"
					/>
					<button
						onClick={() => removeTerm(i)}
						className="btn btn-danger ml-2"
					>
						X
					</button>
				</div>
			))}

			<button onClick={addTerm} className="btn btn-outline-light mt-2">
				+ Add
			</button>
		</div>
	);
};

export default TermsAndConditionsComp;
